module.exports = __webpack_public_path__ + "bddc42340f804a318b3658379607ef0d.png";